import React from 'react';

type Props = {
    className       :   string
    currentStatus   :   any // Here old ampersand model
}

export default function StatusIcon(props: Props) {

    const classes = Classes("ui5-icon-with-dot i5-status-with-dot s-14", props.className)

    return (
        <div className={classes}>
            <div className={Classes('color-dot', 'status-color-{0}'.f(props.currentStatus.color))}/>
        </div>
    );
}
